import React from 'react';

import { useBoolean } from 'hooks/useBoolean';

import RideItemsRow from '../RideItemsRow';
import StationEditor from '../StationEditor';
import StationViewer from '../StationViewer';

const Stations = ({ stationData, reconciliation, onCopyRideId, onSaveSuccess }) => {
	const [isEditing, { setToTrue: startEditing, setToFalse: stopEditing }] = useBoolean();

	const { stations, stationActuals, rideItems, breakdown, isProblematic } = stationData;
	const { sequences, sequenceGroupId, firstStation, lastStation } = reconciliation;

	return (
		<>
			<RideItemsRow
				rideItems={rideItems}
				isProblematic={isProblematic}
				onCopyRideId={onCopyRideId}
			/>
			{isEditing ? (
				<StationEditor
					sequences={sequences}
					stations={stations}
					stationActuals={stationActuals}
					sequenceGroupId={sequenceGroupId}
					firstStation={firstStation}
					lastStation={lastStation}
					onCancel={stopEditing}
					onSaveSuccess={() => {
						stopEditing();
						onSaveSuccess?.();
					}}
				/>
			) : (
				<StationViewer
					stations={stations}
					stationActuals={stationActuals}
					breakdown={breakdown}
					sequences={sequences}
					onEditData={startEditing}
				/>
			)}
		</>
	);
};

export default Stations;
